import { Box, Dialog } from "@mui/material";

export default function ManualAddTrainingDialog({ open, onClose, onAddRisk }) {
  return (
    <Dialog open={open} onClose={onClose} onAddRisk={onAddRisk}>
      This is not enabled yet.
    </Dialog>
  );
}
